import React, { useEffect , useMemo} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Selector from "../../../Selector";

function SearchTransporterField({
  transporters,
  mainGroup,
  className,
  getFilteredTransporters,
  setFilteredTransporters,
  filterState
}) {

  useEffect(()=>{
    getFilteredTransporters();
  },[getFilteredTransporters])

  const checkSingleTransporter = useMemo(()=>{
    const transportersOptions = [
      ...transporters,
    ].map((b) => ({ label: `${b.external_id} ${b.name}`, value: b.id }));

    if(transportersOptions.length===2){

      const singleTransporter = transporters.map((b) => ({ label: `${b.external_id} ${b.name}`, value: b.id }));

      return singleTransporter
    }else{
        return transportersOptions
    }
  },[transporters])


  return (
    ["transporter"].indexOf(mainGroup) !== -1 && (
      <Selector
        value={filterState}
        className={className}
        options={checkSingleTransporter}
        label="Selecionar a Transportadora"
        isMulti
        placeholder="Busque a transportadora..."
        onChange={(value) => {
          Array.isArray(value)?
          setFilteredTransporters(value) :
          value ? setFilteredTransporters([value]) : setFilteredTransporters([]);
        }}
        width="350px"
      />
    )
  );
}

SearchTransporterField.propTypes = {
  transporters: PropTypes.array.isRequired,
  mainGroup: PropTypes.string.isRequired,
  filteredTransporters: PropTypes.array,
  onBranchSelected: PropTypes.func,
};

SearchTransporterField.defaultProps = {
  transporters: [],
};

const mapState = (state) => ({
  transporters: state.transporters.transporters,
  filteredTransporters: state.transporters.filteredTransporters,
  filterState: state.transporters.filterState
});

const mapDispatch = (dispatch) => ({
  setFilteredTransporters: (payload) => dispatch.transporters.setFiltered(payload),
  getFilteredTransporters: () => dispatch.transporters.setFilteredAsync()
});

export default connect(mapState, mapDispatch)(SearchTransporterField);
